import { render, staticRenderFns } from "./date-widget.vue?vue&type=template&id=1543498c&scoped=true&"
import script from "./date-widget.vue?vue&type=script&lang=js&"
export * from "./date-widget.vue?vue&type=script&lang=js&"
import style0 from "./date-widget.vue?vue&type=style&index=0&id=1543498c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1543498c",
  null
  
)

export default component.exports